

























































































import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoUser from '@/components/Molecules/co-user/CoUser.vue';
import CoSkeleton from '@/components/Atoms/co-skeleton/CoSkeleton.vue';
import CoDropdown from '@/components/Molecules/co-dropdown/CoDropdown.vue';
import CoDropdownItem from '@/components/Molecules/co-dropdown-item/CoDropdownItem.vue';
import CoConfirmation from '@/components/Molecules/co-confirmation/CoConfirmation.vue';
import CoIcon from '@/components/Atoms/co-icon/CoIcon.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoThumbnail from '@/components/Molecules/co-thumbnail/CoThumbnail.vue';
import CoDate from '@/components/Molecules/co-date/CoDate.vue';
import CoLink from '@/components/Atoms/co-link/CoLink.vue';
import { User } from '@/types/GlobalTypes';

import axios from 'axios';
import EventBus from '@/eventBus';

interface Note {
    ID: string;
    SpaceID: string;
    UserID?: string; // ID of the user for whom the note is created
    AuthorID: string; // user ID of the author of the note
    AuthorName: string; // Name of the author
    Timestamp: number; // Timestamp when the note was created
    Text: string; // The content of the note, which is HTML formatted text
    Author?: User; // User object of the author, containing details like ID, Name, ImageURL, etc.
    Parent?: {
        ID: string;
        Name: string;
        IconURL: string;
    };
}

export default {
    name: 'CoNote',
    components: {
        CoCard,
        CoUser,
        CoSkeleton,
        CoDropdown,
        CoDropdownItem,
        CoConfirmation,
        CoIcon,
        CoText,
        CoThumbnail,
        CoDate,
        CoLink,
    },
    props: {
        note: {
            type: Object as () => Note,
            default: () => ({}),
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            deleting: false,
            deleted: false,
        };
    },
    methods: {
        deleteUserNote(id) {
            if (this.deleting || this.deleted) return; // Prevent multiple deletions
            this.deleting = true;
            axios({
                method: 'DELETE',
                url: `/admin/notes/${id}`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.deleted = true;
                    this.$emit('delete', id);
                })
                .catch((error) => {
                    this.deleting = false;
                    EventBus.$emit('ERROR', {
                        Message: 'Error deleting user note',
                        Details: error,
                    });
                });
        },
    },
};
